import React from "react";
import PromisesList from "components/promises/PromisesList";
import Loading from "components/common/Loading";
import usePromises from "hooks/promises/usePromises";
import useAuth from "hooks/useAuth";
import { createPromise } from "api/promises.api";

const Promises = () => {
  const {
    promises,
    isLoading,
    getNextPage,
    page,
    setPage,
    hasMoreItems,
    totalCount,
    counts,
  } = usePromises();
  const { currentUser } = useAuth();
  return isLoading && promises.length === 0 ? (
    <Loading />
  ) : (
    <PromisesList
      promises={promises}
      totalCount={totalCount}
      counts={counts}
      currentUserId={currentUser?.id}
      currentUserType={currentUser?.type}
      currentUserDisplayName={currentUser?.displayName}
      isLoadingNextPage={isLoading}
      hasMoreItems={hasMoreItems}
      getNextPage={getNextPage}
      page={page}
      setPage={setPage}
      createPromise={createPromise}
    />
  );
};

export default Promises;
